import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 9.5a5.5 5.5 0 1 0 11 0a5.5 5.5 0 1 0 -11 0","key":"svg-0"}],["path",{"d":"M9 14.5a5.5 5.5 0 1 0 11 0a5.5 5.5 0 1 0 -11 0","key":"svg-1"}]]

const IconChartCircles = createReactComponent('outline', 'chart-circles', 'ChartCircles', __iconNode);

export default IconChartCircles;